import { Pathnames, createLocalizedPathnamesNavigation } from "next-intl/navigation";
import generatedPathnames from './pathnames'

/**
 * READ THIS!
 * Adding a language here?
 * 1. Add a translation to the `lang` folder
 * 2. Add the correct types to `InterfaceLang` and `InterfaceLocale`
 * 3. Add the language to `interfaceLanguages` in utils/constants.ts
 * 4. Add the flag to `mapLanguageToFlag` in utils/constants.ts
 * 5. Add the flag and native name to `mapLocaleToFlagAndNativeName` in utils/constants.ts
 * 6. Finally add the language to the `locales` array below
 */
export const locales = [
    "en", // English
    "ja", // Japanese
    "ko", // Korean
    "zh", // Chinese
    "pt-br", // Portuguese
    "es", // Spanish
    "fr", // French
    "de", // German
    "it" // Italian
] as const;

export const localePrefix = "as-needed";

export const pathnames = generatedPathnames satisfies Pathnames<typeof locales>;

export const { Link, redirect, usePathname, useRouter } =
createLocalizedPathnamesNavigation({ locales, pathnames, localePrefix });
